import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getWorkingUnit(
  pathname,
  queryParams = "",
  headers = undefined,
) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers,
  }); // pathname is "/role"
}

export async function createWorkingUnit(pathname, queryParams = "", body) {
  return await instance({
    baseURL: baseURL,
  }).post("/working-unit" + pathname + queryParams, body);
}

export async function updateWorkingUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).put("/working-unit" + pathname, body);
}

export async function deleteWorkingUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/working-unit" + pathname, { data: body });
}

export async function moveWorkingUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).put("/working-unit" + pathname, body);
}
